import 'bootstrap/dist/css/bootstrap.min.css'

import React from 'react'
import ReactDOM from 'react-dom'
import createSagaMiddleware from 'redux-saga'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import './utils/config'
import authSaga from './state/authSaga'
import authReducer from './state/authReducer'
import Home from './components/Home.jsx'
import Login from './components/login/Login.jsx'
import PrivateRoute from './components/PrivateRoute.jsx'

const sagaMiddleware = createSagaMiddleware()
const reducer = combineReducers({
  auth: authReducer
})

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose

const store = createStore(
  reducer,
  composeEnhancer(
    applyMiddleware(
      sagaMiddleware
    )
  )
)

sagaMiddleware.run(authSaga)

ReactDOM.render(<Provider store={store}>
  <Router>
      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute path="/" component={Home} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
)
